export default __webpack_public_path__ + "static/media/heap.50519a6e.svg";